import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';

const SelectSimple = ({ label, value, setValue, options, ...rest }) => {
    return(
        <FormControl variant="outlined" fullWidth {...rest}>
            <InputLabel htmlFor="outlined-age-native-simple">{ label }</InputLabel>
            <Select
                native
                value={value}
                onChange={(e) => setValue(e.target.value)}
                label={label}
                inputProps={{ name: label }}
            >
                {options.map((item, index) => (
                    <option value={item} key={index}>{item}</option>
                ))}
            </Select>
        </FormControl>
    );
}

export default SelectSimple;